import React, { useContext } from 'react'
import { createPortal } from 'react-dom'
import { HeaderContext } from '../../../../views/LayoutWithLeftSidebar/HeaderContext'
import { ConfigureAssignment } from './ConfigureAssignment/ConfigureAssignment'
import { MeetingInfo } from './MeetingInfo/MeetingInfo'
import { MeetingSummarySidebar } from './Sidebar/MeetingSummarySidebar'
import { MeetingSummaryHeader } from './Header/MeetingSummaryHeader'
import { MeetingResultsWrapper } from './MeetingResults/MeetingResultsWrapper'
import { MeetingSummaryToast } from './Toast/MeetingSummaryToast'
import { MeetingSummaryPoller } from './Poller/MeetingSummaryPoller'
import { MeetingSummaryInitialization } from './Initialization/MeetingSummaryInitialization'
import { useConsentCheck, useTrackRoomSessionOpened } from './hooks'
import { ConsentNotAvailable } from '../ConsentNotAvailable'
import { Col, Container, Row } from 'react-bootstrap'
import { MeetingOverallSentiment } from './SentimentAnalysis/MeetingOverallSentiment'
import { MeetingSummaryModalManager } from '../../../../components/MeetingSummaryModalManager/MeetingSummaryModalManager'
import { MeetingBusinessEvents } from './BusinessEvents/MeetingBusinessEvents'
import { useAppSelector } from '../../../../store/hooks'
import { selectIsHistoryMode } from '../../../../store/meetingSummary/contactUpdate'
import { ExternalUpdateHistoryView } from '../../../../views/UpdateExternalContact/ExternalUpdateHistoryView'
import { ZoomOBFWarningRow } from '../../../../components/ZoomOBFWarning/ZoomOBFWarningRow'

export const MeetingSummary: React.FC = () => {
  const { portalRef } = useContext(HeaderContext)
  useTrackRoomSessionOpened()

  const { meetingDisabledByConsent, consentLoading, meetingUnlocked, meetingApprovalCheck } = useConsentCheck()
  const isHistoryMode = useAppSelector(selectIsHistoryMode)

  if (meetingApprovalCheck && !meetingUnlocked && (consentLoading || meetingDisabledByConsent)) {
    return <ConsentNotAvailable loading={consentLoading} />
  }

  if (isHistoryMode) {
    return (
      <div className='full-size-content'>
        <MeetingSummaryInitialization />
        <>
          <MeetingSummaryPoller />
          <MeetingSummaryToast />
          {portalRef && portalRef.current ? createPortal(<MeetingSummaryHeader />, portalRef.current) : null}
          <MeetingSummarySidebar />
          <MeetingSummaryModalManager />
          <ExternalUpdateHistoryView />
        </>
      </div>
    )
  }

  return (
    <div className='full-size-content'>
      <MeetingSummaryInitialization />
      <>
        <MeetingSummaryPoller />
        <MeetingSummaryToast />
        {portalRef && portalRef.current ? createPortal(<MeetingSummaryHeader />, portalRef.current) : null}
        <MeetingSummarySidebar />
        <MeetingSummaryModalManager />
        <Container className='mw-100 w-100 d-flex flex-column gap-3'>
          <Row className='d-flex justify-content-between flex-wrap gap-3'>
            <Col>
              <MeetingInfo />
            </Col>
            <Col xs='auto' className='p-0 d-flex align-items-center gap-4'>
              <MeetingOverallSentiment />
              <MeetingBusinessEvents />
            </Col>
          </Row>
          <ZoomOBFWarningRow colProps={{ className: 'p-0' }} />
        </Container>
        <div className='p-0 zocks-mt-3.5 zocks-mb-3.5'>
          <ConfigureAssignment />
        </div>
        <MeetingResultsWrapper />
      </>
    </div>
  )
}
